module.exports = __webpack_public_path__ + "static/media/like_512.5d6672ee.png";